import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import NavHeader from './navheader'
import Footer from './footer'
import SubMenu from './submenu'
import MetaTags from 'react-meta-tags'

class TermsOfService extends Component {

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        // console.log('metatag')

        return (
            <div>
                <NavHeader history={this.props.history} />
                <SubMenu ref={d => this.submenu = d} history={this.props.history} />
                <div className="container main-bg">
                    <MetaTags>
                        <title>{'ส่งสด - บริการส่งของสดจากตลาด'}</title>
                        <meta property="og:title" content={'ส่งสด บริการส่งของสด'} />
                        <meta property="og:url" content={window.location.href} />
                        <meta property="og:image" content={'imgsrc'} />
                        <meta property="og:description" content={'บริการส่งของสดจาก ตลาดยิ่งเจริญ ที่คัดสรรคุณภาพของวัตถุดิบโดยผู้ซื้อสินค้าส่วนตัว'} />
                        <meta property="og:type" content='website' />
                        <meta property="fb:pages" content="129193147647837" />
                    </MetaTags>
                    <div className='container'>
                        <div className="row" style={{ backgroundColor: '#fafafa' }}>
                            <Col style={{ paddingLeft: 50 }}>
                                <h2 style={{ paddingLeft: 30, paddingTop: 20 }}>เงื่อนไขในการให้บริการ</h2>
                            </Col>
                        </div>
                    </div>

                    <div className='container'>
                        <Col style={{ paddingLeft: 50, paddingRight: 50 }}>
                            <p>บริษัท ยิ่งเจริญ เฟรชเมท จำกัด (“บริษัทฯ”) ผู้ให้บริการขายและจัดส่งสินค้าจากตลาด ผ่านแพลตฟอร์ม ส่งสด.com (songsod.com) (“ส่งสด”) มีเงื่อนไขการให้บริการดังต่อไปนี้</p>
                            <br />
                            <h4 style={{ paddingLeft: 30 }}>ขั้นตอนสั่งซื้อสินค้า</h4>
                            <p style={{ textAlign: 'center' }}>ขั้นตอนการสั่งซื้อสินค้ากับทางส่งสดมีขั้นตอนดังต่อไปนี้</p>
                            <p>1. เลือกสินค้าผ่านระบบตะกร้าจากทางหน้าเว็บไซต์</p>
                            <p>2. เลือกสถานที่จัดส่งและวิธีการชำระเงิน</p>
                            <p>3. ลูกค้าทำการสั่งซื้อผ่านระบบ ระบบจะแจ้งราคาที่ยังไม่ได้ทำการตรวจสอบ</p>
                            <p>4. หลังจากที่เจ้าหน้าที่บริษัทฯได้รับคำสั่งซื้อ จะทำการตรวจสอบราคาจากตลาดและแจ้งยอดที่ต้องชำระและรอการยืนยันการสั่งซื้อจากลูกค้า</p>
                            <p>5. หลังจากที่ลูกค้าได้ทำการยืนยันการสั่งซื้อและลูกค้าได้ทำการชำระเงินเรียบร้อยแล้ว เจ้าหน้าที่บริษัทฯ จะดำเนินการซื้อและจัดเตรียมส่งสินค้า</p>
                            <p>6. หลังจากทำการสั่งซื้อเรียบร้อยแล้ว บริษัทฯ จะทำการจัดส่งสินค้าพร้อมใบเสร็จ ไปยังสถานที่จัดส่งที่ได้แจ้งกับทางระบบไว้</p>
                            <br />
                            <h4 style={{ paddingLeft: 30 }}>การชำระเงินค่าสินค้า</h4>
                            <p style={{ textAlign: 'center' }}>ลูกค้าสามารถชำระเงินได้ทั้งหมด 3 วิธี ดังต่อไปนี้</p>
                            <p>1. โอนเงินผ่านธนาคาร</p>
                            <p>2. บริการเก็บเงินปลายทาง เฉพาะรายการที่มียอดการสั่งซื้อไม่เกิน 1,000 บาท (มีค่าธรรมเนียมเพิ่มเติม 40 บาท)</p>
                            <p>3. ชำระเงินผ่านบัตรเครดิต (บัตร VISA / Master Card / JCB)</p>
                            <br />
                            <h4 style={{ paddingLeft: 30 }}>การยกเลิกการสั่งซื้อสินค้า</h4>
                            <p>1. หลังจากขั้นตอนการตรวจสอบราคา ลูกค้าสามารถทำการยกเลิกการสั่งซื้อสินค้าได้ในกรณีที่ยังไม่ได้ทำการยืนยันการสั่งซื้อสินค้ากับทางเจ้าหน้าที่บริษัทฯ โดยไม่มีค่าธรรมเนียมในการยกเลิก</p>
                            <p>2. หากลูกค้าทำการยืนยันการสั่งซื้อกับทางเจ้าหน้าที่บริษัทฯแล้ว จะไม่สามารถยกเลิกการสั่งซื้อสินค้าได้</p>
                            <br />
                            <h4 style={{ paddingLeft: 30 }}>การคืนเงิน</h4>
                            <p style={{ textAlign: 'center' }}>ลูกค้าสามารถขอทำการคืนเงินได้ในกรณีดังต่อไปนี้</p>
                            <p>1. ลูกค้าสามารถปฏิเสธการรับสินค้าและขอทำการคืนเงินได้ หากสินค้าที่ท่านได้รับไม่ถูกต้องตรงกับที่ท่านได้ทำรายการผ่านระบบ โดยมีสาเหตุเนื่องจากว่าเป็นความผิดพลาดของเจ้าหน้าที่บริษัทฯ</p>
                            <p>2. หากสินค้าที่ท่านได้รับไม่ได้คุณภาพตามที่ท่านคาดหวังไว้</p>
                            <p style={{ paddingLeft: 50 }}>ท่านสามารถแจ้งผ่านทางบริษัทฯ เพื่อทำการตรวจสอบรายละเอียด เพื่อขอทำการปฏิเสธการรับสินค้า และขอคืนเงินได้ โดยบริษัทฯ จะคืนเงินให้ท่าน ภายใน 3 วันทำการ</p>
                            <br />
                            <h4 style={{ paddingLeft: 30 }}>การเปลี่ยนสินค้า</h4>
                            <p style={{ textAlign: 'center' }}>ลูกค้าสามารถขอทำการเปลี่ยนสินค้าได้ในกรณีดังต่อไปนี้</p>
                            <p>1. ลูกค้าสามารถเปลี่ยนสินค้าได้ หากสินค้าที่ท่านได้รับไม่ถูกต้องตรงกับที่ท่านได้ทำรายการผ่านระบบ โดยมีสาเหตุเนื่องจากว่าเป็นความผิดพลาดของเจ้าหน้าที่บริษัทฯ</p>
                            <p>2. หากสินค้าที่ท่านได้รับไม่ได้คุณภาพตามที่ท่านคาดหวังไว้</p>
                            <p style={{ paddingLeft: 50 }}>ท่านสามารถแจ้งผ่านทางบริษัทฯ เพื่อทำการตรวจสอบรายละเอียด และขอทำการเปลี่ยนสินค้าได้</p>
                            <br />
                            <h4 style={{ paddingLeft: 30 }}>การจัดส่งสินค้า</h4>
                            <p>• บริษัทฯ จัดส่งในพื้นที่ให้บริการที่ได้แจ้งไว้เท่านั้น</p>
                            <p>• บริษัทฯ จะจัดส่งสินค้าตามสถานที่จัดส่งที่ท่านได้แจ้งไว้ โดยมีค่าบริการคิดตามระยะทาง</p>
                            <p>• ในกรณีจัดส่งสินค้า หากพนักงานจัดส่งไปถึงและไม่มีผู้รับสินค้า หากบริษัทฯ ทำการติดต่อลูกค้าไม่ได้ จะถือว่ายกเลิกการสั่งซื้อและไม่มีการคืนเงินค่าสินค้า</p>
                            <br />
                            <br />
                        </Col>
                    </div>
                </div>
                <Footer />
            </div >
        )
    }
}

export default TermsOfService


// WEBPACK FOOTER //
// ./src/components/page_terms_of_service.js